import { logAnalyticsEvent } from "@/constants/amplitude";
import { EventLinkTypes, WebEventProps, WebEventTypes } from "@/constants/event";
import {
    FAQ_LINK,
    PRIVACY_POLICY,
    REFUND_POLICY_LINK_BY_LNG,
    SUPPORT_LINK_BY_LNG,
    TERMS_OF_USE,
} from "@/constants/externalLinks";
import { Languages } from "@/constants/languages";
import { useLocalization } from "@/hooks/useLocalization";
import useAnswers from "@/utils/useAnswers";
import useServer from "@/utils/useServer";

import { usePrefix } from "./usePrefix";

const configureSupportLink = (uuid: string, email: string, lng: Languages) => {
    const url = new URL(SUPPORT_LINK_BY_LNG[lng]);

    url.searchParams.append("tf_anonymous_requester_email", email);
    url.searchParams.append("tf_360022621660", uuid);

    return url.toString();
};

const useExternalLinkWithAnalytics = (screen: string) => {
    const { getEventType } = usePrefix();
    const { email } = useAnswers();
    const { uuid } = useServer();
    const { language } = useLocalization();

    const handleExternalLinkClick = (type: EventLinkTypes) => () => {
        const url = {
            [EventLinkTypes.privacyPolicy]: PRIVACY_POLICY.link[language],
            [EventLinkTypes.refundPolicy]: REFUND_POLICY_LINK_BY_LNG[language],
            [EventLinkTypes.termsOfUse]: TERMS_OF_USE.link[language],
            [EventLinkTypes.supportLink]: configureSupportLink(uuid as string, email, language),
            [EventLinkTypes.faq]: FAQ_LINK,
        }[type];

        window.open(url, "_blank", "noopener,noreferrer");
        logAnalyticsEvent(WebEventTypes.WEB_LINK_CLICK, {
            [WebEventProps.SCREEN]: getEventType(screen),
            [WebEventProps.TYPE]: type,
        });
    };

    return { handleExternalLinkClick };
};

export default useExternalLinkWithAnalytics;
